'use client';

import { Button } from "@/components/Button";
import { useWorkflowContext } from "./WorkflowContext";

export function CreateAvatarButton() {
    let { startWorkflow } = useWorkflowContext();


    function handleCreateAvatarClicked() {
        if (startWorkflow) startWorkflow();
    }

    return <Button type="button" variant="secondary" onClick={handleCreateAvatarClicked}>Create avatar &nbsp; ➜</Button>;
}
